import { AxiosMode } from '@/axiosModel';
import type { BookItem, ProjectConfigData } from '@/types';

export type { BookItem };

export interface BookListParams {
  page?: number;
  pageSize?: number;
  keyword?: string;
  auditStatus?: BookItem['auditStatus'] | '';
  sortBy?: 'newTime' | 'updateTime';
  sortOrder?: 'asc' | 'desc';
}

export interface BookListResult {
  list: BookItem[];
  total: number;
  page: number;
  pageSize: number;
}

const apis = new AxiosMode();

export const BOOK_API_BASE = AxiosMode.API_HOST + '/api/aipicturebook';

export async function getBook(id: string | number): Promise<BookItem> {
  const { req } = apis.get({ remotePath: `${BOOK_API_BASE}/get?id=${id}` });
  const res: any = await req;
  return res.data;
}

export async function updateBook(
  id: string | number,
  data: ProjectConfigData,
  title?: string,
  cover?: string,
  newFileList?: Record<string, string[]>,
  oldFileList?: Record<string, string[]>
): Promise<void> {
  const postData: any = {
    id,
    config: JSON.stringify(data)
  };

  if (title) {
    postData.title = title;
  }

  if (newFileList && Object.keys(newFileList).length > 0) {
    postData.newFileList = newFileList;
  }

  if (oldFileList && Object.keys(oldFileList).length > 0) {
    postData.oldFileList = oldFileList;
  }

  if (cover) {
    postData.cover = cover;
  }

  // console.log('update book:', postData);

  const { req } = apis.post({
    postData,
    remotePath: `${BOOK_API_BASE}/update`
  });
  await req;
}

export async function uploadBookFont(id: string | number, family: string, fontFile: Blob) {
  const postData = new FormData();
  postData.append('id', String(id));
  postData.append('family', family);
  postData.append('fontFile', fontFile);

  const { req } = apis.post({
    postData,
    remotePath: `${BOOK_API_BASE}/save-font-file`
  });

  const res: any = await req;

  return res.data;
}

export async function fetchBookList(params: BookListParams): Promise<BookListResult> {
  const { req } = apis.post({
    postData: params,
    remotePath: AxiosMode.API_HOST + '/api/book/list'
  });
  const res: any = await req;
  return res.data;
}

export async function deleteBook(id: string): Promise<void> {
  const { req } = apis.post({
    postData: { id },
    remotePath: AxiosMode.API_HOST + '/api/book/delete'
  });
  await req;
}

export async function getShareUrl(id: string): Promise<string> {
  const { req } = apis.post({
    postData: { id },
    remotePath: AxiosMode.API_HOST + '/api/book/share-url'
  });
  const res: any = await req;
  return res.data;
}
